import React, { useState } from 'react';
import { FileTextIcon } from '@fronton/icons-react';
import { Divider, List, ListItem } from 'fronton-react';
import { divider, fileTextIconWrapper, listItem, productQualityDocumentsWrapper } from './styles';
import { ProductQualityDrawer } from './components/product-quality-drawer/product-quality-drawer';
import { MobileModal } from './components/mobile-modal/mobile-modal';
import { useDispatch, useSelector } from 'react-redux';
import { getDeviceType } from 'common/selectors/device-type';
import { FETCH_TRUST_DOCUMENTS } from './ducks/actions';
import { getManuals, getSource } from 'features/product-info';
import {
  getIsAllowedToSellMarkingProducts,
  getTrustDocumentsError,
  getTrustDocumentsList,
  getTrustDocumentsLoading,
} from './ducks/selector';

const FileTextIconWrapper = () => (
  <div className={fileTextIconWrapper}>
    <FileTextIcon type="outline" size="l" color="text-primary" />
  </div>
);

const PRODUCT_QUALITY_DOCUMENTS_DATA_QA = 'product-quality-documents';

export const NO_CERTIFICATION_REQUIRED_TEXT = 'Товар не подлежит обязательной сертификации';
const MARKING_COMPLIANCE_TEXT = 'Продавец исполняет требования о маркировке';

export const ProductQualityDocuments = () => {
  const dispatch = useDispatch();
  const [showDrawer, setShowDrawer] = useState(false);
  const device = useSelector(getDeviceType);
  const manuals = useSelector(getManuals);
  const isMarketplace = useSelector(getSource)?.toUpperCase() === 'PIM';
  const certificates = useSelector(getTrustDocumentsList);
  const isAllowedToSellMarkingProducts = useSelector(getIsAllowedToSellMarkingProducts);
  const isNoCertificationRequiredText = !certificates.length;
  const isLoading = useSelector(getTrustDocumentsLoading);
  const isError = useSelector(getTrustDocumentsError);

  const handleOpenDrawer = () => {
    setShowDrawer(true);
    if (isMarketplace) {
      dispatch(FETCH_TRUST_DOCUMENTS.request());
    }
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  const onClickRetry = () => {
    if (isMarketplace) {
      dispatch(FETCH_TRUST_DOCUMENTS.request());
    }
  };

  const additionalText = [
    isNoCertificationRequiredText ? NO_CERTIFICATION_REQUIRED_TEXT : '',
    isAllowedToSellMarkingProducts ? MARKING_COMPLIANCE_TEXT : '',
  ].filter(Boolean);

  const drawerProps = {
    manuals: manuals || [],
    certificates,
    show: showDrawer,
    onClose: handleCloseDrawer,
    additionalText,
    isLoading,
    isError: !!isError,
    onRetry: onClickRetry,
  };

  return (
    <section data-qa={PRODUCT_QUALITY_DOCUMENTS_DATA_QA} className={productQualityDocumentsWrapper}>
      <List>
        <ListItem
          className={listItem}
          iconLeft={<FileTextIconWrapper />}
          text="Документы на товар"
          value="Документы на товар"
          onClick={handleOpenDrawer}
        />
      </List>

      <Divider className={divider} />

      {device === 'mobile' ? <MobileModal {...drawerProps} /> : <ProductQualityDrawer {...drawerProps} />}
    </section>
  );
};
